import styled from 'styled-components'
import { Popover } from '@mui/material'

interface Props {
  id: string
  open: boolean
  text: JSX.Element | string
  anchorEl: any
  handleClose: () => void
}

export default function PopoverMessage({ id, open, text, anchorEl, handleClose }: Props): JSX.Element {
  return (
    <StyledPopover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClick={handleClose}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
    >
      <PopoverText>{text}</PopoverText>
    </StyledPopover>
  )
}

const StyledPopover = styled(Popover)`
  & .MuiPopover-paper {
    border: 1px dotted;
    border-color: ${(props) => props.theme.customPalette.error};
  }
`

const PopoverText = styled.div`
  padding: 20px;
  width: 100%;
`
